import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import EssentialProductCard from "../card/product/EssentialProductCard";
import BestSellingProductsSectionSkeleton from "./skeleton/BestSellingProductsSectionSkeleton";
import { MostSaledProductsInterface } from "../../constants/Landing";

const BestSellingProductsSection = ({
  isBestSellingProductsDataLoading,
  bestSellingProductsData,
}: {
  isBestSellingProductsDataLoading: boolean;
  bestSellingProductsData: MostSaledProductsInterface[] | undefined;
}) => {
  return (
    <Box>
      <Text
        textStyle={"h-title"}
        textAlign={{ base: "center", lg: "left" }}
        mb={"16px"}
      >
        Produk Terlaris
      </Text>
      {isBestSellingProductsDataLoading ? (
        <BestSellingProductsSectionSkeleton />
      ) : (
        <SimpleGrid
          w={"full"}
          columns={{ base: 2, sm: 3, md: 4, xl: 6, "3xl": 8 }}
          gap={{ base: "12px", md: "16px", xl: "24px", "2xl": "32px" }}
        >
          {bestSellingProductsData?.map((product, index) => (
            <EssentialProductCard
              key={index}
              imageSrc={
                product?.main_picture
                  ? `${process.env.REACT_APP_MEDIA_URL}${product?.main_picture}`
                  : ""
              }
              name={product.name}
              lowestPrice={product.lowest_price}
              category={product?.category || ""}
              slug={product?.slug}
            />
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default BestSellingProductsSection;
